import { useLocation, useNavigate } from "react-router-dom";
import { scrollTo, scrollToTop } from "./scrollTo";

export type HomeScrollTarget = "top" | "about" | "products" | "contacts";

export interface HomeNavigationState {
  scrollTo?: HomeScrollTarget;
}

export const useHomeNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (target: HomeScrollTarget) => {
    if (location.pathname === "/") {
      if (target === "top") {
        scrollToTop();
      } else {
        scrollTo(target);
      }

      return;
    }

    navigate("/", {
      state: { scrollTo: target } satisfies HomeNavigationState,
    });
  };
};
